
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/password-reset-request",
      function () {
        return require("private-next-pages/password-reset-request/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/password-reset-request"])
      });
    }
  